import { RegistrationFormData, RegistrationStepProps } from "./StepModel";
import { Dispatch } from "react";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { incrementCurrentStep } from "../RegistrationPageSlice";
import CPLPasswordInput from "cpl-react-common/components/Inputs/CPLPasswordInput";

export const PasswordStep: React.FC<RegistrationStepProps> = ({ formikProps }) => (
  <>
    {/* begin::Form group */}
    <div className="fv-row mb-3">
      <label className="form-label fw-bolder fs-6 mb-0" htmlFor="password">
        Password
      </label>
      <CPLPasswordInput
        className="form-control bg-transparent"
        id="password"
        getFieldProps={formikProps.getFieldProps}
        autocomplete="off"
        data-test-id="registration-form__password-input"
      />
    </div>
    <div className="fv-row mb-10">
      <label className="form-label fw-bolder fs-6 mb-0" htmlFor="passwordConfirmation">
        Confirm Password
      </label>
      <CPLPasswordInput
        className="form-control bg-transparent"
        id="passwordConfirmation"
        getFieldProps={formikProps.getFieldProps}
        autocomplete="off"
        data-test-id="registration-form__confirm-password-input"
      />
    </div>
    {/* end::Form group */}
  </>
);

export const PasswordSubmit = (
  values: RegistrationFormData,
  dispatch: Dispatch<AnyAction>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  thunkDispatch: ThunkDispatch<any, any, any>
) => {
  dispatch(incrementCurrentStep());
};
